import { theme } from "@tm/utility/global";
import styled from "styled-components";

export const HeaderTitle = styled.h2`
  font-weight: 400;
  font-size: 14px;
  color: ${theme.greyText};
`;

export const ModalBody = styled.div`
  padding: 16px 30px 30px;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  gap: 8px;
`;

export const BenefitItem = styled.div`
  display: flex;
  align-items: center;
  background: #f5f5f5;
  gap: 16px;
  border-radius: 16px;
  padding: 12px;
  font-weight: 400;
  font-size: 14px;
`;

export const BenefitIcon = styled.div`
  img {
    border-radius: 8px;
    object-fit: contain;
  }
`;
